export const PHONE_REGEX = new RegExp(
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/
);
export const DIGIT_REGEX = new RegExp(/^\d+$/);
export const NOT_STRICT_DIGIT_REGEX = new RegExp(/\d/);
export const LOWERCASECASE_REGEX = new RegExp(/[a-z]/);
export const UPPERCASE_REGEX = new RegExp(/[A-Z]/);
